// src/client/components/RouteFallback.tsx
//
// lazy route chunk の読み込み中に出す表示 (CLAUDE.md §11: loading 状態を空白にしない)。
// 見た目は AppShell の <Suspense fallback> と同じ (「読み込み中...」 の 1 行)。
//
// 使う場所:
//  - App.tsx の RouterProvider の外側 (AppShell を通らない /m・/print・/liff の lazy chunk 用)
//  - router.tsx の /m (FieldMobile)
//
// chunk の読み込み失敗 (deploy 直後の旧 chunk 404) は各 route group の errorElement
// (RouteErrorBoundary) が受けて自動 reload する。 ここは「読み込み中」 だけを担う。

import { useTranslation } from "react-i18next";

export function RouteFallback(): JSX.Element {
  const { t } = useTranslation();
  return (
    <p className="px-4 py-8 text-center text-sm text-muted-foreground" role="status">
      {t("common.loading")}
    </p>
  );
}
